import { render, staticRenderFns } from "./LicAuth.vue?vue&type=template&id=204a6c36&scoped=true&"
import script from "./LicAuth.vue?vue&type=script&lang=js&"
export * from "./LicAuth.vue?vue&type=script&lang=js&"
import style0 from "./LicAuth.vue?vue&type=style&index=0&id=204a6c36&lang=css&scoped=true&"
import style1 from "./LicAuth.vue?vue&type=style&index=1&id=204a6c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a6c36",
  null
  
)

export default component.exports